<template>
  <div class="header-details gap-6 grid grid-cols-2 grid-rows-1 rounded-lg">
    <job-opportunity-details
      :job="job"
      data-cy="job-opportunity-details"
      @save-success="refreshJob"
    />
    <div v-if="showJobCost" class="flex flex-col gap-6">
      <job-commissions-details :job="job" @save-success="refreshJob" />
      <job-details class="d-flex flex-column" :job="job" />
    </div>
    <job-commissions-details v-else :job="job" @save-success="refreshJob" />
    <job-times-details :job="job" />
    <job-cost-details v-if="showJobCost" :job-cost="job.job_cost" />
    <job-details v-else class="d-flex flex-column" :job="job" />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";

import JobCommissionsDetails from "@/Job/Commissions/JobCommissionsDetails.vue";
import JobCostDetails from "@/Job/Header/JobCostDetails.vue";
import JobTimesDetails from "@/Job/Header/JobTimesDetails.vue";
import JobOpportunityDetails from "@/Job/Opportunity/JobOpportunityDetails.vue";
import JobDetails from "./JobDetails.vue";

export default {
  components: {
    JobCommissionsDetails,
    JobCostDetails,
    JobOpportunityDetails,
    JobTimesDetails,
    JobDetails
  },
  computed: {
    ...mapState(["job"]),
    ...mapGetters(["featureEnabledForTenant"]),
    showJobCost() {
      return (
        this.featureEnabledForTenant("job_costing_ff_enabled") &&
        Boolean(this.job.job_cost)
      );
    }
  },
  methods: {
    ...mapActions(["fetchJob"]),
    refreshJob() {
      this.fetchJob({ jobId: this.job.id });
    }
  }
};
</script>

<style lang="scss" scoped>
.header-details {
  font-size: 0.75rem;
  padding: 1rem;
  background-color: var(--light-gray);
}
.item-section {
  padding: 0 10px;
}
</style>
